import _ from 'lodash';
import { useSelector } from 'react-redux';
import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';

interface ApplicantElement {
  applicant_id: number;
  username: string;
  applicant_name: string;
  intermidiary: string;
  vat_num: string;
}

interface Paging {
  page: number;
  pageSize: number;
  total: number;
}

interface ApplicantListData {
  paging: Paging;
  items: ApplicantElement[];
}

interface IApplicantListOutput {
  status: StateStatus;
  data: ApplicantListData | null;
}

export const useGetApplicants = (): IApplicantListOutput => {
  const data = useShallowEqualSelector(
    (state: any) => state[ReducerKeys.APPLICANT_LIST_REDUCER].applicantsList
  );
  return data;
};
